import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { UserTablePopupsTypes } from "./PopupTypes";
import { CloseIcon, SearchIcon } from "../iconSet/IconSet";
import { UsersTypes } from "../../Data";
import DataTable from "react-data-table-component";
import { customStyles } from "./CustomDataTableStyles";
import TableNoData from "../tablePartComp/TableNoData";
import TableTitle from "../tablePartComp/TableTitle";
import UserDataTable from "./UserDataTable";

const userColumns = [
  //{name: 'ID', selector: (row: UsersTypes) => row.id},
  { name: "Username", selector: (row: UsersTypes) => row.username },
  { name: "Department", selector: (row: UsersTypes) => row.department },
];

const UserTablePopup = (props: UserTablePopupsTypes) => {
  const [selectedRows, setSelectedRows] = useState<UsersTypes[]>([]);

  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState<UsersTypes[]>([]);

  const [error, setError] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [users, setUsers] = React.useState<UsersTypes[]>([]);

  const [isTableLoading, setIsTableLoading] = useState<boolean>(false)

  const BASE_URL = process.env.REACT_APP_BASE_URL

  const handleSelectRow = ({ selectedRows, }: { selectedRows: UsersTypes[]; }) => {
    setSelectedRows(selectedRows);
  };

  // Handle search
  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const text = event.target.value;
    setFilterText(text);

    if (text === "") {
      setFilteredData(users);
    } else {
      const filtered = users.filter((item) =>
        Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value.toString().toLowerCase().includes(text.toLowerCase());
          }
          return false;
        })
      );
      setFilteredData(filtered);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsTableLoading(true)
      const token = localStorage.getItem("access_token");
      //fetch("https://bos.beconx.live/api/v1/getallusers", {
      fetch(BASE_URL + "/identity_manager/api/v1/getallusers", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }) //fetch("http://localhost:8001/users")
        .then((res) => res.json())
        .then(
          (result: UsersTypes[]) => {
            setIsLoaded(true);
            setUsers(result);
            //const temp: UsersTypes[] = result.filter(obj => obj.hazardtype === props.hazardType)
            // setFilteredData(temp)
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
        .finally(() => setIsTableLoading(false))
    }, 1000);
  }, []);

  const handleAddClick = useCallback(() => {
    //props.selectedRows(selectedRows)
    if (props.function) {
      props.function(selectedRows);
    }
    //console.log('data >>>>> ', selectedRows)
    props.setWindowState(false);
  }, [selectedRows]);

  return (
    <div className={`workflow-popup`}>
      <div className={`workflow-popup-wrapper`}>
        <div className={`title`}>
          <span>{props.title}</span>
          <CloseIcon
            width="1.2rem"
            color="var(--color-main-red)"
            onClick={(e) => props.setWindowState(false)}
          />
        </div>
        <div className={`data-wrapper`}>
          <UserDataTable data={users} setSelectedRows={setSelectedRows} isLoading={isTableLoading}/>
          {/* <div className={`search-box-wrapper`}>
            <div className={`input-wrapper`}>
              <i>
                <SearchIcon color="var(--color-main-white)" width="1.2rem" />
              </i>
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => handleSearch(e)}
              />
            </div>
          </div>
          <div className={`table-box`}>
            <DataTable
              title={<TableTitle title="select users"/>}
              columns={userColumns}
              data={filterText ? filteredData : users}
              customStyles={customStyles}
              onSelectedRowsChange={handleSelectRow}
              pagination
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15]}
              selectableRows
              highlightOnHover
              noDataComponent={<TableNoData />}
            />
          </div> */}
          <div className={`button-wrapper`} style={{ gridArea: "buttons" }}>
            <div className={`left-side`}></div>
            <div className={`right-side`}>
              <button className={`button-normal`} onClick={handleAddClick}>
                add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTablePopup;